/**
 * SecondAura : survol des cartes après un retour arrière.
 *
 * Quand on revient sur une page avec le bouton « précédent », le navigateur la ressort telle qu'il l'avait rangée,
 * y compris « la souris est sur telle carte », même si elle n'y est plus. La carte sur laquelle on avait cliqué
 * restait donc sur sa 2e photo jusqu'au prochain mouvement de souris.
 *
 * Tant que la souris n'a pas bougé, on coupe l'effet de survol des cartes : l'attribut `data-sa-survol-fige` est
 * posé sur <html> et lu par les règles CSS du survol (snippets/product-card-styles.liquid pour les cartes produit,
 * sections/sa-selection.liquid pour « La sélection » de l'accueil). Au premier mouvement, le navigateur sait de
 * nouveau où est la souris et l'attribut est retiré.
 */
const ATTRIBUT = 'data-sa-survol-fige';
const racine = document.documentElement;

function figer() {
  racine.setAttribute(ATTRIBUT, '');
  window.addEventListener('pointermove', () => racine.removeAttribute(ATTRIBUT), { once: true, passive: true });
}

// En quittant la page : elle sera rangée avec le survol déjà coupé.
window.addEventListener('pagehide', (event) => {
  if (event.persisted) racine.setAttribute(ATTRIBUT, '');
});

// En y revenant.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) figer();
});
